import { FACEBOOK_PAGE_URL } from '../constants/facebookPageUrl';

/**
 * Curated “post” rows for the storefront social section when `/api/social/posts`
 * is missing, errors, or returns an empty list.
 *
 * Same shape as live posts from your backend (Meta Graph API, etc.):
 * - id: string (unique)
 * - platform: 'instagram' | 'facebook' | 'linkedin'
 * - url: link when the card is clicked
 * - image: optional absolute URL to an image (omit to use site logo fallback in UI)
 * - caption: short text shown on the card
 * - timestamp: optional ISO date string
 * - mediaType: optional 'VIDEO' to show play badge
 *
 * Do not scrape Instagram/Facebook from the client: it violates Meta’s terms,
 * breaks when HTML changes, and is blocked by CORS and login walls. Edit this
 * file when you want to refresh placeholder cards until `/api/social/posts` (e.g. Meta Graph API) is wired.
 */

export const SOCIAL_FEED_FALLBACK_POSTS = [
  {
    id: 'fallback-instagram-1',
    platform: 'instagram',
    url: 'https://www.instagram.com/raheasyke/',
    image: null,
    caption:
      'Follow @raheasyke on Instagram for new arrivals, savings tips, and what’s new at Raheasy.',
    timestamp: null,
  },
  {
    id: 'fallback-facebook-1',
    platform: 'facebook',
    url: FACEBOOK_PAGE_URL,
    image: null,
    caption:
      'Join us on Facebook for updates, offers, and conversations with the Raheasy community.',
    timestamp: null,
  },
  {
    id: 'fallback-linkedin-1',
    platform: 'linkedin',
    url: 'https://www.linkedin.com/in/fatuma-osman-319750200/',
    image: null,
    caption:
      'Connect with us on LinkedIn for business updates, roles, and what we are building at Raheasy.',
    timestamp: null,
  },
];
